const addClassToGrandParent = () => {
  const popupForm = document.querySelector('[aria-label="POPUP Form"]');

  if (popupForm) {
    const grandParent = popupForm.parentElement?.parentElement;
    if (grandParent && !grandParent.classList.contains('klaviyo-popup-form')) {
      grandParent.classList.add('klaviyo-popup-form');
    }
  }
};

// Run the function every 500ms to check and add the class if missing
const interval = setInterval(addClassToGrandParent, 500);

/* Mobile Slider on collecton page -- Start */
function initMobileSwipers() {
  const initializedClass = 'mobile-swiper--ready';

  function pauseAllVideos() {
    document.querySelectorAll('.mobile-swiper__media-item video').forEach(video => {
      video.pause();
      video.currentTime = 0;
    });
  }

  function resetOtherSliders(currentSwiper) {
    document.querySelectorAll('.mobile-swiper-custom').forEach((otherSwiper) => {
      if (otherSwiper !== currentSwiper && otherSwiper.classList.contains(initializedClass)) {
        const otherFlickity = Flickity.data(otherSwiper);
        if (otherFlickity) otherFlickity.select(0);
      }
    });
  }

  function handleSlide(swiperEl, index) {
    const slides = swiperEl.querySelectorAll('.mobile-swiper__media-item');
    const video = slides[index] && slides[index].querySelector('video');
    if (video) {
      pauseAllVideos();
      video.play();
      resetOtherSliders(swiperEl);
    }

    const image = slides[index] && slides[index].querySelector('img');
    if (image && index > 0) {
      pauseAllVideos();
      resetOtherSliders(swiperEl);
    }
  }

  function checkVideoVisibility() {
    document.querySelectorAll('.mobile-swiper__media-item video').forEach(video => {
      const rect = video.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top < -0.4 * windowHeight || rect.bottom > 1.4 * windowHeight) {
        video.pause();
      }
    });
  }

  // Attach once
  window.removeEventListener('scroll', checkVideoVisibility);
  window.addEventListener('scroll', checkVideoVisibility);

  // Init function
  document.querySelectorAll('.mobile-swiper-custom').forEach(swiperEl => {
    if (swiperEl.classList.contains(initializedClass)) return;

    const flkty = new Flickity(swiperEl, {
      cellAlign: 'left',
      contain: true,
      pageDots: true,
      prevNextButtons: false,
    });

    swiperEl.classList.add(initializedClass);

    flkty.on('change', (index) => {
      handleSlide(swiperEl, index);
    });

    flkty.on('ready', () => {
      handleSlide(swiperEl, flkty.selectedIndex);
    });
  });
}

// Run initially
initMobileSwipers();

// Observe new swipers added later
const observer = new MutationObserver(() => {
  initMobileSwipers();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
/* Mobile Slider on collecton page -- End */





const htmlElement = document.documentElement;
const announcementBar = document.querySelector('.utility-bar');
const sectionHeader = document.querySelector('.header');

function updateHeights() {
    const announceHeight = announcementBar.offsetHeight;
    const headerHeight = sectionHeader.offsetHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    let totalHeight;
    if (scrollTop >= announceHeight) {
        // Fully scrolled past announcement bar
        totalHeight = headerHeight;
    } else {
        // Gradually subtract the scrolled amount from announcement height
        totalHeight = headerHeight + (announceHeight - scrollTop);
    }
    
    htmlElement.style.setProperty('--header-announce-height', totalHeight + 'px');
}

// Update on scroll
window.addEventListener('scroll', updateHeights);
// Update on resize
window.addEventListener('resize', updateHeights);
// Initial update
updateHeights();